<template>
	<div class="dashboard" style="margin-top:4%;">
		<top-header></top-header>
        <b-container fluid class="mb-4">
            <b-row>
                <b-col class="px-0">
                <b-img v-bind="mainProps" class="d-none d-sm-block" src="https://www.alluraa.com/media/images/promo.jpg" fluid></b-img>
                <b-img v-bind="mainProps" class="d-block d-sm-none" src="https://www.alluraa.com/media/images/promo-mobile.jpg" fluid></b-img>
                </b-col>
            </b-row>
        </b-container>
		<b-container fluid class="content">
			<b-row class="mb-4">
				<b-col cols="12" md="6" class="px-4">
                    <p class="text-left promo-title">Become a Seller</p>
                    <div class="promo-text pt-4 d-none d-md-block">
                        Sign up as a seller on Alluraa and take your brand to every corner of the country. With Alluraa, your product reach multiplies immediately through the word of mouth publicity of our trained and trusted {{$root.INFLUENCER_TEXT}}s. This ensures higher sales, profitability, and connect with the customers.
                    </div>
					<div class="text-center py-4 d-none d-md-block">
                        <b-link class="button btn-solid" href="/marketing/seller">Explore</b-link>
                    </div>
                </b-col>
                <b-col cols="12" md="6">
					<b-img v-bind="mainProps" src="https://www.alluraa.com/media/images/promo-seller.jpg" fluid></b-img>
                </b-col>
                <b-col cols="12" md="6" class="px-4 pt-4 d-block d-sm-block d-md-none">
                    <div class="promo-text">
                        Sign up as a seller on Alluraa and take your brand to every corner of the country. With Alluraa, your product reach multiplies immediately through the word of mouth publicity of our trained and trusted {{$root.INFLUENCER_TEXT}}s. This ensures higher sales, profitability, and connect with the customers.
                    </div>
					<div class="text-center py-4">
                        <b-link class="button btn-solid" href="/marketing/seller">Explore</b-link>
                    </div>
                </b-col>
			</b-row>
            <b-row class="mb-4">
                <b-col cols="12" md="6" class="px-4 d-block d-sm-block d-md-none">
                    <p class="text-left promo-title">Become an {{$root.INFLUENCER_TEXT}}</p>
                </b-col>
				<b-col cols="12" md="6">
					<b-img v-bind="mainProps" src="https://www.alluraa.com/media/images/promo-sales-advisor.jpg" fluid></b-img>
                </b-col>
                <b-col cols="12" md="6" class="px-4">
                    <p class="text-left promo-title d-none d-md-block">Become an {{$root.INFLUENCER_TEXT}}</p>
                    <div class="promo-text pt-4">
                        The {{$root.INFLUENCER_TEXT}}s at Alluraa act as the bridge between the brands and the buyers. They get the opportunity to learn and enhance their selling skills and improve knowledge, which can help them sell more and earn more – Be your own Boss in a real sense!
                    </div>
					<div class="text-center py-4">
                        <b-link class="button btn-solid" :href="'/marketing/'+$root.INFLUENCER">Explore</b-link>
                    </div>
                </b-col>
			</b-row>
			
		</b-container>
		<top-footer></top-footer>
		
	</div>
</template>
<script>
/*import Header from "@/components/header-promo.vue";
import Footer from "@/components/footer-promo.vue";*/
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'promo';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
	},
	mounted(){
        /*let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
        document.head.appendChild(recaptchaScript);

        let s1 = document.createElement('script');
        s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
        document.head.appendChild(s1);*/
        this.initload();
        
	},
	data() {
		return{
            modal_data: {
                price: 0,
                special_price: 0
            },
            mainProps: { fluidGrow: true, class: 'm1' },
			slide:0,
			related_products: [],
			url: this.$root.WEBURL+'relatedproducts',
		};
	},
	methods: {
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                products: 1
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.related_products = response.data.result.related_products;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	},
	metaInfo() {
		return{
			title: 'Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
                { name: 'description', content: 'alluraa' },
                { name: 'google-site-verification', content: 'C0WP9JxlesVhxC-oa2ieqde4w5HvgBehOytgMpiNktA' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
}


</script>
